import { CustomizerDataType } from "../../Types/Layout/ThemeCustomizerTypes";

export const navLinkList: CustomizerDataType[] = [
    {
        path: 'https://docs.pixelstrap.net/react/riho/document/',
        image: '2.png',
        name: 'Document',
        class:"fa-spin"
    },
    {
        path: 'https://themeforest.net/user/pixelstrap/portfolio',
        image: '3.png',
        name: 'Buy Now'
    },
    {
        path: 'https://landing.pixelstrap.net/react/riho/template/landing-page.html',
        image: '4.png',
        name: 'Check Features'
    },
    {
        path: 'https://support.pixelstrap.com',
        image: '5.png',
        name: 'Support'
    }
]

export const lightColorData = [
    {
        primary:"#006666",
        secondary:"#FF6150"
    },
    {
        primary:"#1D5B79",
        secondary:"#A16B56"
    },
    {
        primary:"#4A55A2",
        secondary:"#A97D5D"
    },
    {
        primary:"#167A93",
        secondary:"#233d46"
    },
    {
        primary:"#423964",
        secondary:"#897D5e"
    },
    {
        primary:"#4b2a4b",
        secondary:"#d98c72"
    }
]

export const darkColorData = [
    {
        primary:"#006666",
        secondary:"#FF6150"
    },
    {
        primary:"#1D5B79",
        secondary:"#A16B56"
    },
    {
        primary:"#4A55A2",
        secondary:"#A97D5D"
    },
    {
        primary:"#167A93",
        secondary:"#233d46"
    },
    {
        primary:"#423964",
        secondary:"#897D5e"
    },
    {
        primary:"#3949ab",
        secondary:"#d98c72"
    }
]